import envConfig from "../config";
import { isOlivsApiSuccess } from "./api";
import { getCookie } from "./cookie-utils";

const activateCreatedUrl = () =>
  `https://${envConfig.apiDev1}/api/v3/en-au/users/activate-created?BaseHostURL=${envConfig.loginUrl}`;

const activateCreatedHeaders = {
  Accept: "application/json",
  "Content-Type": "application/json",
  "olivs-api-real-ip": "127.0.0.2",
  "olivs-api-computer-name": "EC2AMAZ-QF1CQAD",
  "api-key": "OlivsAuth",
};

/** After verify-mfa: email + phone verified and account still in created (E) status. */
export function shouldActivateCreatedUser(session) {
  if (!session || typeof session !== "object") {
    return false;
  }
  const flagY = (v) => String(v ?? "").trim().toUpperCase() === "Y";
  const status = String(session.status ?? "").trim().toUpperCase();
  return (
    flagY(session.loginEmailVerifiedYN) &&
    flagY(session.mobPhoneNoVerifiedYN) &&
    status === "E"
  );
}

/** POST activate-created (registration / pending-created users). */
export async function activateCreatedUser(loginSecuredHash) {
  const hash = loginSecuredHash || getCookie("loginSecuredHash");
  if (!hash) {
    return {
      ok: false,
      errorMessage: "Missing login credentials",
      data: null,
    };
  }

  try {
    const response = await fetch(activateCreatedUrl(), {
      method: "POST",
      headers: activateCreatedHeaders,
      body: JSON.stringify({ LoginSecuredHash: hash }),
    });
    const data = await response.json().catch(() => ({}));
    const ok = isOlivsApiSuccess(data, response.ok);
    return {
      ok,
      errorMessage: ok
        ? null
        : data?.ErrorMessage ?? data?.errorMessage ?? "Account activation failed",
      data,
    };
  } catch (error) {
    console.error("activate-created error:", error);
    return {
      ok: false,
      errorMessage: "Account activation failed. Please try again.",
      data: null,
    };
  }
}
